import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-tai-chi-yoga': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga&exp=web_tai_chi_male_checkout_update~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_tai_chi_male_checkout_update'),
			},
		},
		'activity-male-tai-chi-yoga-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_tai_chi_male_checkout_update~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_tai_chi_male_checkout_update'),
			},
		},
	},
]

export default config
